<template>
  <div class="stat-cards">
    <div class="stat-card">
      <span class="stat-card__label">Total de Animais</span>
      <span class="stat-card__value">{{checkTotals ? totals.animals : 0}}</span>
    </div>

    <div class="stat-card">
      <span class="stat-card__label">Produção Total</span>
      <span class="stat-card__value">{{checkTotals ? totals.milk_production : 0}}</span>
    </div>

    <div class="stat-card">
      <span class="stat-card__label">Média de Produção</span>
      <span class="stat-card__value">{{checkTotals ? totals.average : 0}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name:"Presentation",
  props:{
    totals:Object
  },
  computed: {
    checkTotals() {
      return Object.keys(this.totals).length > 0;
    }
  }
}
</script>

<style scoped>
</style>